import React, { useCallback, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Box, Modal } from "@mui/material";
import * as yup from "yup";
import CommonDivider from "../../common/components/divider/CommonDivider";
import LoadingSpinner from "../../common/components/loadingspinner/loadingSpinner";
import CommonDynamicTablePaginationNew from "../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import { UseMilisecondsToDate } from "../../common/components/Custom Hooks/UseMilisecondsToDate";
import { ModalStyle } from "../../common/components/ModalStyle";
import DatePickerField from "../../common/components/FormFields/DatePickerFieldNew";
import { CloseModalIcon } from "../../common/components/assets/commonassets/CommonAssets";
import CommonButton from "../../common/components/Buttons/CommonButton";

const ER_PATIENT_LIST = [
  {
    Id: 1,
    "Patient Name": "Mr. Rajesh Patil",
    UHID: "UHID-2025-001",
    Date: currentDate(true),
    "Arrival Time": "09:12 AM",
    "Triage Start Time": "09:16 AM",
    triageStartBreached: false,
    "Triage End Time": "09:24 AM",
    triageDurationBreached: false,
    "Door To CT": "18 min / 25 min",
    dctBreached: false,
    "Door To Needle": "42 min / 45 min",
    dtnBreached: false,
    "Total Time": "52 min / 60 min",
    ttBreached: false,
    "72 Hrs Return": false,
  },
  {
    Id: 2,
    "Patient Name": "Mrs. Sunita Sharma",
    UHID: "UHID-2025-002",
    Date: currentDate(true),
    "Arrival Time": "10:05 AM",
    "Triage Start Time": "10:12 AM",
    triageStartBreached: true,
    "Triage End Time": "10:28 AM",
    triageDurationBreached: true,
    "Door To CT": null,
    dctBreached: null,
    "Door To Needle": null,
    dtnBreached: null,
    "Total Time": "75 min / 60 min",
    ttBreached: true,
    "72 Hrs Return": true,
  },
  {
    Id: 3,
    "Patient Name": "Mr. Amit Kulkarni",
    UHID: "UHID-2025-003",
    Date: currentDate(true),
    "Arrival Time": "11:40 AM",
    "Triage Start Time": "11:43 AM",
    triageStartBreached: false,
    "Triage End Time": "11:50 AM",
    triageDurationBreached: false,
    "Door To CT": "15 min / 25 min",
    dctBreached: false,
    "Door To Needle": "38 min / 45 min",
    dtnBreached: false,
    "Total Time": "48 min / 60 min",
    ttBreached: false,
    "72 Hrs Return": false,
  },
  {
    Id: 4,
    "Patient Name": "Ms. Pooja Verma",
    UHID: "UHID-2025-004",
    Date: currentDate(true),
    "Arrival Time": "12:18 PM",
    "Triage Start Time": "12:26 PM",
    triageStartBreached: true,
    "Triage End Time": null,
    triageDurationBreached: null,
    "Door To CT": null,
    dctBreached: null,
    "Door To Needle": null,
    dtnBreached: null,
    "Total Time": null,
    ttBreached: null,
    "72 Hrs Return": false,
  },
  {
    Id: 5,
    "Patient Name": "Mr. Rohit Deshmukh",
    UHID: "UHID-2025-005",
    Date: currentDate(true),
    "Arrival Time": "08:55 AM",
    "Triage Start Time": "08:59 AM",
    triageStartBreached: false,
    "Triage End Time": "09:06 AM",
    triageDurationBreached: false,
    "Door To CT": "22 min / 25 min",
    dctBreached: false,
    "Door To Needle": null,
    dtnBreached: null,
    "Total Time": "60 min / 60 min",
    ttBreached: false,
    "72 Hrs Return": false,
  },
  {
    Id: 6,
    "Patient Name": "Ms. Neha Joshi",
    UHID: "UHID-2025-006",
    Date: currentDate(true),
    "Arrival Time": "02:30 PM",
    "Triage Start Time": "02:36 PM",
    triageStartBreached: true,
    "Triage End Time": "02:50 PM",
    triageDurationBreached: true,
    "Door To CT": "28 min / 25 min",
    dctBreached: true,
    "Door To Needle": null,
    dtnBreached: null,
    "Total Time": "82 min / 60 min",
    ttBreached: true,
    "72 Hrs Return": true,
  },
  {
    Id: 7,
    "Patient Name": "Mr. Suresh Naik",
    UHID: "UHID-2025-007",
    Date: currentDate(true),
    "Arrival Time": "04:10 PM",
    "Triage Start Time": "04:13 PM",
    triageStartBreached: false,
    "Triage End Time": "04:21 PM",
    triageDurationBreached: false,
    "Door To CT": "14 min / 25 min",
    dctBreached: false,
    "Door To Needle": "35 min / 45 min",
    dtnBreached: false,
    "Total Time": "45 min / 60 min",
    ttBreached: false,
    "72 Hrs Return": false,
  },
  {
    Id: 8,
    "Patient Name": "Mrs. Anita Chavan",
    UHID: "UHID-2025-008",
    Date: currentDate(true),
    "Arrival Time": "05:50 PM",
    "Triage Start Time": null,
    triageStartBreached: null,
    "Triage End Time": null,
    triageDurationBreached: null,
    "Door To CT": null,
    dctBreached: null,
    "Door To Needle": null,
    dtnBreached: null,
    "Total Time": null,
    ttBreached: null,
    "72 Hrs Return": false,
  },
  {
    Id: 9,
    "Patient Name": "Mr. Vikas More",
    UHID: "UHID-2025-009",
    Date: currentDate(true),
    "Arrival Time": "07:35 AM",
    "Triage Start Time": "07:39 AM",
    triageStartBreached: false,
    "Triage End Time": "07:46 AM",
    triageDurationBreached: false,
    "Door To CT": "20 min / 25 min",
    dctBreached: false,
    "Door To Needle": null,
    dtnBreached: null,
    "Total Time": "58 min / 60 min",
    ttBreached: false,
    "72 Hrs Return": false,
  },
  {
    Id: 10,
    "Patient Name": "Mrs. Meena Iyer",
    UHID: "UHID-2025-010",
    Date: currentDate(true),
    "Arrival Time": "07:20 PM",
    "Triage Start Time": "07:32 PM",
    triageStartBreached: true,
    "Triage End Time": "07:52 PM",
    triageDurationBreached: true,
    "Door To CT": null,
    dctBreached: null,
    "Door To Needle": null,
    dtnBreached: null,
    "Total Time": "95 min / 60 min",
    ttBreached: true,
    "72 Hrs Return": true,
  },
];
function currentDate(isPrevious = false, isformatedDate = true) {
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  if (!isPrevious) {
    return UseMilisecondsToDate(today, "dd-MM-yyyy");
  } else {
    if (!isformatedDate) {
      return yesterday;
    } else {
      return UseMilisecondsToDate(yesterday, "dd-MM-yyyy");
    }
  }
}
const ER_SUMMARY_COUNTS = [
  {
    id: "doorToNeedle",
    title: "Door To Needle",
    count: 3,
    description: "Stroke Patients Treated",
    gradient: "from-rose-500 via-pink-500 to-red-600",
    icon: "💉",
  },
  {
    id: "doorToCT",
    title: "Door To CT",
    count: 6,
    description: "CT Scan Completed",
    gradient: "from-indigo-500 via-blue-500 to-cyan-500",
    icon: "🧠",
  },
  {
    id: "completedTriage",
    title: "Completed Triage",
    count: 8,
    description: "Patients Triaged",
    gradient: "from-emerald-500 via-green-500 to-lime-500",
    icon: "🩺",
  },
  {
    id: "return72",
    title: "72 Hrs Return",
    count: 3,
    description: "Revisited ER",
    gradient: "from-orange-500 via-amber-500 to-yellow-500",
    icon: "🔁",
  },
  // {
  //   id: "inTAT",
  //   title: "Within TAT",
  //   count: 5,
  //   description: "Met Target Time",
  //   gradient: "from-emerald-500 via-green-500 to-lime-500",
  //   icon: "⏱️",
  // },
];

function ERPatientListmodal({
  openErPatientListModal,
  setOpenErPatientListModal,
}) {
  const { control, watch, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      fromDate: currentDate(true, false),
      toDate: new Date(),
    },
  });
  const [dataResult, setDataResult] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [searchString, setSearchString] = useState(null);
  const [isBackDrop, setIsBackdrop] = useState(false);
  const [isShowSpinner, setIsShowSpinner] = useState(false);
  const [listingObject, setListingObject] = useState({
    page: 0,
    size: rowsPerPage,
    searchString: "",
    searchId: searchString?.id ? searchString?.id : null,
    fromDate: null,
    toDate: null,
    passTypeId: null,
  });
  const fromDate = watch("fromDate");
  const toDate = watch("toDate");
  const populateTable = (forPagination) => {
    let searchObj = {
      page: !forPagination ? 0 : page,
      searchString: "",
      size: rowsPerPage,
      searchId: searchString?.value ? searchString?.value : null,
      fromDate: fromDate
        ? UseMilisecondsToDate(new Date(fromDate), "yyyy-MM-dd")
        : null,
      toDate: toDate
        ? UseMilisecondsToDate(new Date(toDate), "yyyy-MM-dd")
        : null,
    };
    setIsShowSpinner(true);
    setTimeout(() => {
      setCount(ER_PATIENT_LIST?.length);
      setDataResult(ER_PATIENT_LIST);
      setIsShowSpinner(false);
    }, 2000);

    // if (page === 0) {
    //   setIsShowSpinner(true);
    // }
    // getAllVisitorList(searchObj)
    //   .then((response) => response.data)
    //   .then((res) => {
    //     if (res.statusCode === 200 || res.statusCode === 204) {
    //       if (forPagination === true) {
    //         setDataResult((prevData) => [...prevData, ...res.result]);
    //         setIsShowSpinner(false);
    //       } else {
    //         setDataResult(res.result);
    //         setIsShowSpinner(false);
    //         setPage(0);
    //       }
    //       setCount(res.count);
    //     } else {
    //       errorAlert(res.message);
    //       setIsShowSpinner(false);
    //     }
    //     // setUserAction(res?.actions);
    //   })
    //   .catch((error) => {
    //     console.log(error);

    //     setIsShowSpinner(false);
    //   });
  };

  const renderInput = useCallback((row, index, header) => {
    console.log("headerheaderheader", header);

    return (
      <div className="py-1 text-center">
        {header === "72 Hrs Return" && (
          <p
            className={`p-1 font-medium border rounded-full text-center text-xs w-1/2 ${
              row["72 Hrs Return"]
                ? "bg-red-100 text-red-700 border-red-300"
                : "bg-green-100 text-green-700 border-green-300"
            }`}
          >
            {row["72 Hrs Return"] ? "Yes" : "No"}
          </p>
        )}
        {header === "Triage Start Time" && (
          <p
            style={{
              color: row?.triageStartBreached ? "#c10007" : "",
              fontWeight: row?.triageStartBreached ? 600 : 400,
            }}
          >
            {row["Triage Start Time"] ?? "-"}
          </p>
        )}
        {header === "Triage End Time" && (
          <p
            style={{
              color: row?.triageDurationBreached ? "#c10007" : "",
              fontWeight: row?.triageDurationBreached ? 600 : 400,
            }}
          >
            {row["Triage End Time"] ?? "-"}
          </p>
        )}
        {header === "Door To CT" && (
          <p
            style={{
              color: row?.dctBreached ? "#c10007" : "",
              fontWeight: row?.dctBreached ? 600 : 400,
            }}
          >
            {row["Door To CT"] ?? "-"}
          </p>
        )}
        {header === "Door To Needle" && (
          <p
            style={{
              color: row?.dtnBreached ? "#c10007" : "",
              fontWeight: row?.dtnBreached ? 600 : 400,
            }}
          >
            {row["Door To Needle"] ?? "-"}
          </p>
        )}
        {header === "Total Time" && (
          <p
            style={{
              color: row?.ttBreached ? "#c10007" : "",
              fontWeight: row?.ttBreached ? 600 : 400,
            }}
          >
            {row["Total Time"] ?? "-"}
          </p>
        )}
      </div>
    );
  }, []);
  const renderTableHeader = () => {
    return (
      <>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span
            style={{
              width: "12px",
              height: "12px",
              backgroundColor: "#c10007",
              display: "inline-block",
            }}
          />
          <span>Cross the benchmarks</span>
        </div>
      </>
    );
  };

  // Function to render actions in the table
  const renderActions = (row, index) => {
    return <div className="flex gap-1"></div>;
  };
  console.log("yesterDate", currentDate(true));

  useMemo(() => {
    populateTable();
  }, [
    listingObject?.passTypeId,
    listingObject?.searchId,
    listingObject?.fromDate,
    listingObject?.toDate,
    listingObject?.searchString,
  ]);
  return (
    <Modal
      open={openErPatientListModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={ModalStyle} className="w-[95%] h-[93%] overflow-auto rounded-lg">
        <div className=" flex justify-between items-center ">
          <h1 className="font-semibold">ER Patient TAT</h1>
          <CommonButton
            label={<CloseModalIcon />}
            className="closeModalButton"
            onClick={() => {
              setOpenErPatientListModal(false);
            }}
          />
        </div>
        <div className="py-1">
          <CommonDivider color="#B3B3B3" height={1} />
        </div>
        <div className="grid md:grid-cols-3 lg:grid-cols-5 items-center gap-x-2 ">
          <DatePickerField
            name="fromDate"
            label="From Date"
            control={control}
            inputFormat="dd/MM/yyyy"
            slotProps={{ textField: { size: "small" } }}
          />
          <DatePickerField
            name="toDate"
            label="To Date"
            control={control}
            inputFormat="dd/MM/yyyy"
            slotProps={{ textField: { size: "small" } }}
          />
          <div className="flex  flex-wrap  gap-2">
            <CommonButton
              searchIcon={true}
              className={"px-4 rounded-md bg-customBlue text-white"}
              onClick={() => {
                // populateTable();
                setListingObject((listingObject) => ({
                  ...listingObject,
                  searchString: "",
                  searchId: searchString?.value ? searchString?.value : null,
                  fromDate: fromDate
                    ? UseMilisecondsToDate(new Date(fromDate), "yyyy-MM-dd")
                    : null,
                  toDate: toDate
                    ? UseMilisecondsToDate(new Date(toDate), "yyyy-MM-dd")
                    : null,
                }));
              }}
            />
            <CommonButton
              label={"Reset"}
              className=" border border-customRed text-customRed "
              onClick={() => {
                setSearchString(null);
                setListingObject((listingObject) => ({
                  ...listingObject,
                  searchString: "",
                  searchId: null,
                  fromDate: null,
                  toDate: null,
                }));
                setValue("searchableSelect", null);
                setValue("fromdate", null);
                setValue("toDate", null);
              }}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 my-2">
          {ER_SUMMARY_COUNTS?.map((item) => (
            <div
              key={item.id}
              className={`relative overflow-hidden rounded-2xl p-3 bg-gradient-to-br ${item.gradient}
          text-white shadow-lg hover:shadow-2xl transition-all duration-300`}
            >
              {/* Icon */}
              <div className="absolute right-4 top-6 text-5xl opacity-50">
                {item.icon}
              </div>

              {/* Title */}
              <h4 className="text-sm font-semibold tracking-wide opacity-90">
                {item.title}
              </h4>

              {/* Count */}
              <div className="mt- text-3xl font-extrabold">{item.count}</div>

              {/* Description */}
              <p className="mt- text-xs opacity-85">{item.description}</p>

              {/* Bottom Accent */}
              <div className="absolute bottom-0 left-0 h-1 w-full bg-white/30" />
            </div>
          ))}
        </div>

        <div className="">
          {isShowSpinner ? (
            <div className="flex justify-center my-28">
              <LoadingSpinner />
            </div>
          ) : (
            <div>
              {dataResult && dataResult.length > 0 ? (
                <CommonDynamicTablePaginationNew
                  dataResult={dataResult}
                  rowsPerPage={rowsPerPage}
                  //   renderActions={renderActions}
                  renderInput={renderInput}
                  renderTableHeader={renderTableHeader}
                  setPage={setPage}
                  tableClass="capitalize"
                  count={count}
                  page={page}
                  populateTable={populateTable}
                  highlightRow={false}
                  setRowsPerPage={setRowsPerPage}
                  removeHeaders={[
                    "Id",
                    "triageStartBreached",
                    "triageDurationBreached",
                    "dctBreached",
                    "dtnBreached",
                    "ttBreached",
                  ]}
                  editableColumns={[
                    "In TAT",
                    "72 Hrs Return",
                    "Triage Start Time",
                    "Triage End Time",
                    "Door To CT",
                    "Door To Needle",
                    "Total Time",
                  ]}
                />
              ) : (
                <>
                  {!isShowSpinner && (
                    <p className="text-center  my-28 w-full text-gray-600">
                      No Record Found<span className="animate-pulse">...</span>
                    </p>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
}
export default ERPatientListmodal;
